import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

const initialState = { 
    hardwood_label: 'Hardwood',
    hardwood_value: 'Hardwood',
    show_hardwood: true,
    hardwood_visible: true,
    cedar_label: 'Cedar',
    cedar_value: 'Cedar',
    show_cedar: true,  
    cedar_visible: true,
    black_label: 'Black',
    black_value: 'Black',
    show_black: true,
    black_visible: true
};

const initDeliveryMulchTypes = ( state, action ) => {
    return updateObject( state, { 
        hardwood_label: 'Hardwood',
        hardwood_value: 'Hardwood',
        show_hardwood: true,
        hardwood_visible: true,
        cedar_label: 'Cedar',
        cedar_value: 'Cedar',
        show_cedar: true,  
        cedar_visible: true,
        black_label: 'Black',
        black_value: 'Black',
        show_black: true,
        black_visible: true
     } );
};


const updateDeliveryMulchType = ( state, action ) => {
    return updateObject( state, {
        [action.idToken]: action.value
    } );
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.INIT_DELIVERY_MULCH_TYPES : return initDeliveryMulchTypes( state, action );
        case actionTypes.UPDATE_DELIVERY_MULCH_TYPE: return updateDeliveryMulchType( state, action );
        default: return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/deliveryMulchTypes.js